import { ComputedBackend, createFlags } from 'flag'
import { get } from 'lodash-es'

export const hasEnv = (key: string) => Boolean(getEnv(key, ''))
export const getEnv = (key: string, defaultValue = ''): string =>
  get(window, ['env', key], defaultValue)

const usesGateway = hasEnv('WAYLAY_API_GATEWAY_URL')

function hasService(srvcKey: string): boolean {
  if (usesGateway) return true
  const serviceUrl = getEnv(`WAYLAY_${srvcKey}_URL`)
  if (serviceUrl) return true
  return false
}

function hasFeature(key: string, srvcKey = ''): boolean {
  const enabled = getEnv(`WAYLAY_${key}_ENABLE`, null)
  if (enabled) return Boolean(enabled === 'true')
  // if not explicitely (dis/en)abled, fall back to endpoint config
  return hasService(srvcKey || key)
}

type FlagValue = boolean | { [key: string]: boolean }
type FeatureFlags = Record<string, FlagValue>

const flags = new ComputedBackend<FeatureFlags>({
  alarms: hasFeature('ALARMS'),
  byoml: hasFeature('BYOML'),
  nlp: false, // NLP service has been removed
  storage: hasFeature('STORAGE'),
  plugRegistry: hasFeature('REGISTRY'),
  webscripts: hasFeature('WEBSCRIPTS'),
  usage: hasFeature('USAGE'),
  queries: hasFeature('QUERIES'),
  explore: hasFeature('EXPLORE', 'QUERIES'),
  etl: hasFeature('ETL') && hasService('STORAGE'),
  docsUrl: hasEnv('WAYLAY_DOCS_URL'),
  applications: hasEnv('WAYLAY_APPLICATIONS_KEY'),
  disableUserManagement: getEnv('DELEGATED_LOGIN') === 'true',
  whitelabeling: getEnv('ENABLE_WHITELABELING') === 'true',
  edgeMode: getEnv('ENABLE_EDGE_MODE') === 'true',
  converter: false, // Converter service has been removed
  usesGateway,
})

const { FlagBackendProvider, Flag, useFlag } = createFlags<FeatureFlags>()
export { FlagBackendProvider, Flag, useFlag }

export default flags
